enum HIGHLIGHT_MESSAGE {
    PINNED = 'pinned',
    NEW = 'new',
    RESTOCKED = 'restocked',
    REDUCED = 'reduced',
    NOT_IN_STOCK = 'notInStock',
    PROMOTION = 'promotion'
}

enum HIGHLIGHT_COLOR {
    PURPLE = 'purple',
    ORANGE = 'orange',
    BLUE = 'blue',
    GREEN = 'green',
    CORAL = 'coral'
}

enum SORT_METHOD {
    ALPH_ASC = 'alphabetAsc',
    ALPH_DESC = 'alphabetDesc',
    CAT_FILTER = 'categoryFilter',
    CAT_SUPPLIER = 'categorySupplier',
    MANUAL = 'manual'
}

export {
    HIGHLIGHT_MESSAGE,
    HIGHLIGHT_COLOR,
    SORT_METHOD
}
